import { HeartPulse } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const HeartPulseIcon = createLucideIcon(HeartPulse);
